import { render, staticRenderFns } from "./TestDeliveryDialog.vue?vue&type=template&id=4953c117&scoped=true&"
import script from "./TestDeliveryDialog.vue?vue&type=script&lang=js&"
export * from "./TestDeliveryDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4953c117",
  null
  
)

export default component.exports